export type SyrupType =
  | 'ISOGLUCOSE_SYRUP'
  | 'MILKSUGAR_SYRUP'
  | 'DEXTROSE_SYRUP_AND_MALTODEXTRIN_SYRUP'
  | 'OTHER';

export const SyrupType = {
  IsoglucoseSyrup: 'ISOGLUCOSE_SYRUP' as SyrupType,
  MilksugarSyrup: 'MILKSUGAR_SYRUP' as SyrupType,
  DextroseSyrupAndMaltodextrinSyrup:
    'DEXTROSE_SYRUP_AND_MALTODEXTRIN_SYRUP' as SyrupType,
  Other: 'OTHER' as SyrupType,
};
